import { SET_USER, LOGOUT_USER, LOGIN_USER } from '../actions/types';

const initialState = {
  user: null,
  isAuthenticated: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
      };
    case SET_USER:
      const user = action.payload;
      
      // Validazione dei dati utente per prevenire account Guest incompleti
      if (!user || typeof user !== 'object' || !user.email) {
        console.error("Tentativo di impostare dati utente non validi:", user);
        return state; // Non aggiornare lo stato se i dati non sono validi
      }
      
      // Pausa attiva = flag paused === true E pause_until ancora nel futuro.
      // Difesa secondaria contro flag stale lato Firestore (es. webhook reactivation
      // fallito): se pause_until è scaduto, ignoriamo il flag paused.
      // pause_until può arrivare in formati eterogenei a seconda della source:
      //  - Firestore Timestamp (client SDK): { seconds, nanoseconds } o .toMillis()
      //  - Admin SDK serializzato: { _seconds, _nanoseconds }
      //  - ISO string / millis number (cache localStorage o API custom)
      const pauseUntilMs = (() => {
        const pu = user?.pause_until;
        if (pu == null) return null;
        if (typeof pu === 'number') return pu;
        if (typeof pu === 'string') {
          const ms = new Date(pu).getTime();
          return Number.isNaN(ms) ? null : ms;
        }
        if (typeof pu.toMillis === 'function') return pu.toMillis();
        if (typeof pu.seconds === 'number') return pu.seconds * 1000;
        if (typeof pu._seconds === 'number') return pu._seconds * 1000;
        return null;
      })();
      // Se pause_until è null/mancante, trattiamo come pausa NON attiva
      // (preferiamo dare al cliente l'accesso Premium pagato piuttosto che declassarlo).
      const isPaused = user.paused === true && pauseUntilMs !== null && pauseUntilMs > Date.now();
      const isPremium = user && user.plan === 'Premium';

      // Determina lo stato effettivo da mostrare nel dropdown
      let displayPlan;
      if (isPaused) {
        displayPlan = 'Abbonamento in pausa';
      } else {
        displayPlan = user?.plan || 'Base';
      }

      return {
        ...state,
        user: {
          ...user,
          displayPlan,
          isPaused,
          // Manteniamo il piano Base quando l'abbonamento è in pausa
          // per garantire l'accesso alle funzionalità gratuite
          plan: isPaused ? 'Base' : user?.plan
        },
        isAuthenticated: true,
      };
    case LOGOUT_USER:
      return {
        ...state,
        user: null,
        isAuthenticated: false,
      };
    default:
      return state;
  }
};

export default authReducer;